// Opções "defaults" do preview do gráfico exportado.
export const defaultEchartOption = {
  grid: {
    bottom: '10%',
    top: '20%',
  },
  xAxis: {
    type: 'category',
    data: [''],
  },
  yAxis: {
    type: 'value',
  },
  legend: {
    icon: 'circle',
    top: '5%',
  },
  label: {
    show: true,
    position: 'top',
    formatter: function(bar) {
      return `${bar.value.toFixed(0)}%`
    },
  },
};